import { render } from "./Modulemodal.vue?vue&type=template&id=2bb5a4bc&scoped=true"
import script from "./Modulemodal.js?vue&type=script&lang=js"
export * from "./Modulemodal.js?vue&type=script&lang=js"

import "./Modulemodal.vue?vue&type=style&index=0&id=2bb5a4bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb5a4bc"]])

export default __exports__